import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-navigation-right",
  "use": "n-icon-navigation-right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"n-icon-navigation-right\">\n    <path d=\"M11.6983 10.001L8.2318 14.3608C7.87824 14.7851 7.93556 15.4157 8.35984 15.7692C8.78412 16.1228 9.41468 16.0655 9.76825 15.6412L13.7682 10.6412C14.0773 10.2703 14.0773 9.73166 13.7682 9.36082L9.76825 4.36082C9.41468 3.93654 8.78412 3.87922 8.35984 4.23278C7.93556 4.58634 7.87824 5.21691 8.2318 5.64119L11.6983 10.001Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol